import React from 'react';
import FormGroup from './FormGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface FormDateProps {
  name?: string;
  register?: any;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  required?: boolean;
  error?: any;
  errorMessage?: string;
  helpContent?: React.ReactNode;
  testId?: string;
  joinedButton?: boolean;
  joinedButtonIcon?: any;
  joinedButtonClick?: () => void;
  joinedButtonClassName?: string;
  joinedButtonTitle?: string;
}

const FormDate = ({
  name,
  label,
  placeholder,
  defaultValue,
  register,
  required,
  joinedButton,
  joinedButtonIcon,
  joinedButtonClick,
  joinedButtonClassName,
  joinedButtonTitle,
  error,
  errorMessage,
  helpContent,
  testId,
}: FormDateProps) => (
  <FormGroup
    label={label}
    error={error}
    errorMessage={errorMessage}
    required={required}
    helpContent={helpContent}
  >
    {joinedButton ? (
      <div className="input-group" role="search">
        <input
          {...(name != null ? register(name, { required }) : {})}
          type="date"
          aria-label={label}
          name={name}
          placeholder={placeholder}
          className="form-control float-left"
          style={{ width: 'calc(100% - 45px)' }}
          defaultValue={defaultValue}
          data-lpignore="true"
          autoComplete="off"
          data-cy={testId}
        />
        <button
          type="submit"
          onClick={joinedButtonClick}
          title={joinedButtonTitle}
          className={`btn ${
            joinedButtonClassName || 'btn-primary'
          } float-left r-corners-right`}
        >
          <FontAwesomeIcon icon={joinedButtonIcon} aria-hidden="true" />
        </button>
      </div>
    ) : (
      <input
        {...(name != null ? register(name, { required }) : {})}
        type="date"
        aria-label={label}
        name={name}
        placeholder={placeholder}
        className={`form-control`}
        defaultValue={defaultValue}
        data-lpignore="true"
        autoComplete="off"
        data-cy={testId}
      />
    )}
  </FormGroup>
);
export default FormDate;
